import { queryOptions, useQuery } from '@tanstack/react-query';
import { redirect } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import { apiRequest } from '@/lib/http/http-api';

export type Access = { isAdmin: boolean; permissions: string[] };
export const accessOptions = queryOptions({
  queryKey: ['auth', 'access'],
  queryFn: ({ signal }) => apiRequest<Access>('/auth/access', { signal }),
  staleTime: 0,
});
export const canAccess = (access: Access | undefined, permission: string) =>
  access?.isAdmin === true ||
  access?.permissions.some(
    (p) => p === permission || p === permission.replace(/:read$/, ':write'),
  ) === true;
export const useAccess = () => useQuery(accessOptions);

/** Server checks the current session's official Admin permission AND dynamic business grants. */
export const checkAdminPermission = (
  permission:
    | 'user:impersonate'
    | 'user:delete'
    | 'user:ban'
    | 'session:list'
    | 'session:revoke',
) =>
  apiRequest<{ success: boolean }>('/auth/has-permission', {
    method: 'POST',
    body: { permission },
  });
export const requirePermission = async (
  client: QueryClient,
  href: string,
  permission: string,
) => {
  if (!canAccess(await client.fetchQuery(accessOptions), permission)) {
    throw redirect({ to: '/forbidden', search: { from: href } });
  }
};
